document.querySelectorAll('a[href^="#"]:not([data-app-nav])').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    const href = this.getAttribute('href');

    if (href.startsWith('#') && href.length > 1) {
      e.preventDefault();
      const target = document.querySelector(href);
      const header = document.querySelector('header');
      const headerHeight = header ? header.offsetHeight : 0;

      if (target) {
        const targetPos = target.getBoundingClientRect().top + window.scrollY - headerHeight - 50;
        window.scrollTo({
          top: targetPos,
          behavior: 'smooth'
        });
        setTimeout(function(){
          const targetPos = target.getBoundingClientRect().top + window.scrollY - headerHeight - 50;
          window.scrollTo({
          top: targetPos,
          behavior: 'smooth'
        });
        },1000);
      }  else {
        window.location.href = href;
      }
    } else {
      window.location.href = href;
    }
  });
});